import axios from "axios";
import state from "../store";

const baseURL = state.getters.mainAppURL + "dashboard/";
const getGlobalStats = (params) => axios.get(baseURL + "global_stats", {params});
const getDateWiseSale = (params) => axios.get(baseURL + "date_wise_sales", { params });
const getBranchWiseOrders = (params) => axios.get(baseURL + "branch_wise_count", { params });
const getTopProducts = (params) => axios.get(baseURL + "products_sale_stats", { params });
const getTopAreas = (params) => axios.get(baseURL + "areas_stats", { params });
const getTopCustomers = (params) => axios.get(baseURL + "customer_stats", { params });
const getNewCustomers = (params) => axios.get(baseURL + "monthly_new_customers", { params });
const getOrderTypeStats = (params) => axios.get(baseURL + "takeAway_delivery_orders_count", { params });
const getSaleOfLastSixMonth = (params) => axios.get(baseURL + "monthly_sales", { params });
const getMonthlyAgentStats = (params) => axios.get(baseURL + "agent_stats?"+params);

export {
    getGlobalStats,
    getDateWiseSale,
    getBranchWiseOrders,
    getTopProducts,
    getTopAreas,
    getTopCustomers,
    getNewCustomers,
    getOrderTypeStats,
    getSaleOfLastSixMonth,
    getMonthlyAgentStats
}